import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { SystemCardComponent } from '@/app/shared/cards/system-card/system-card.component';
import { ProjectDetails } from '@/app/interfaces/project';

@Component({
  selector: 'app-project-ai-systems',
  standalone: true,
  imports: [CommonModule, DesyAngularModule, SystemCardComponent],
  templateUrl: './project-ai-systems.component.html',
})
export class ProjectAiSystemsComponent {
  @Input() project: ProjectDetails | null = null;
}
